import React from "react";
const BPKDrive = React.lazy(() => import('./BPKDrive'));
const FormBPKDrive = React.lazy(() => import('./Form'));
const DetailBPKDrive = React.lazy(() => import('./Detail'));

export const bpkDriveConfigs = [
    // {
    //     path: '/apps/bpk-drive',
    //     element: <BPKDrive />,
    //     // roleAccess: ['PRESHARE.USER']
    // },
    // {
    //     path: '/apps/bpk-drive/dokumen/tambah',
    //     element: <FormBPKDrive />,
    //     // roleAccess: ['PRESHARE.USER']
    // },
    // {
    //     path: '/apps/bpk-drive/:type',
    //     element: <BPKDrive />,
    //     // roleAccess: ['PRESHARE.USER']
    // },
    // {
    //     path: '/apps/bpk-drive/:type/:filter',
    //     element: <BPKDrive />,
    //     // roleAccess: ['PRESHARE.USER']
    // },
    // {
    //     path: '/apps/bpk-drive/:type/detail/:id',
    //     element: <DetailBPKDrive />,
    //     // roleAccess: ['PRESHARE.USER']
    // },
    // {
    //     path: '/apps/bpk-drive/:type/detail/:id/:filter',
    //     element: <DetailBPKDrive />,
    //     // roleAccess: ['PRESHARE.USER']
    // },
    // {
    //     path: '/apps/bpk-drive/:type/edit/:id',
    //     element: <FormBPKDrive />,
    //     // roleAccess: ['PRESHARE.USER']
    // },
    // {
    //     path: '/apps/bpk-drive/:type/edit/:id/:filter',
    //     element: <FormBPKDrive />,
    //     // roleAccess: ['PRESHARE.USER']
    // },
];